import Divider from '@material-ui/core/Divider';

/** @deprecated  Exporting the Divider component from the Material UI library. */
export default Divider;
